module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Editar Pessoa'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "required": "",
      "rules": _vm.assuntoSummaryRules255,
      "max-height": "400"
    },
    model: {
      value: (_vm.pessoa.nome),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "nome", $$v)
      },
      expression: "pessoa.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Possui nome social?"
    },
    model: {
      value: (_vm.temNomeSocial),
      callback: function($$v) {
        _vm.temNomeSocial = $$v
      },
      expression: "temNomeSocial"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [(_vm.temNomeSocial) ? _c('v-text-field', {
    attrs: {
      "label": "Nome Social",
      "required": "",
      "rules": _vm.assuntoSummaryRules255,
      "max-height": "400"
    },
    model: {
      value: (_vm.pessoa.nomeSocial),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "nomeSocial", $$v)
      },
      expression: "pessoa.nomeSocial"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarPessoa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cc31d74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/editar-projeto/editar-pessoa.vue
// module id = 632
// module chunks = 0